// The answer. Reasons describe the caller's standing, never the resource: a reason must not tell
// anyone whether a record exists. The HTTP layer maps every deny on a tenant route to the same
// 404-shaped error; the reason is for logs and audit.
export const DENY_REASONS = [
    /** The principal or the resource carries no tenant. */
    'tenant-missing',
    /** The principal is not acting in the resource's tenant and holds no grant on it. */
    'tenant-scope',
    /** A platform resource addressed with a tenant that is not `platform`. */
    'platform-scope',
    /** The action is not in the vocabulary for this resource kind. */
    'unknown-action',
    /** The resource kind has no policy. */
    'unknown-resource',
    /** The policy did not grant it. */
    'not-permitted',
    /** The route's auth kind excludes this principal outright. */
    'route-auth',
    /** A list scope could not be derived from the policy (policy authoring error). */
    'unscopable',
];
export const ALLOWED = Object.freeze({ allowed: true, reason: 'allowed' });
export function deny(reason) {
    return { allowed: false, reason };
}
//# sourceMappingURL=decision.js.map